import type {
  KycVerificationRequestDetail,
  KycVerificationRequestsListResult,
} from "@/modules/wallet/domain/repo/kyc-verification-requests";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type { KycVerificationRequestDetail, KycVerificationRequestsListResult };
export type KycVerificationRequestItem =
  KycVerificationRequestsListResult["data"][number];

export const kycRequestsApi = {
  async list(
    query: OffsetPageQueryDTO,
  ): Promise<KycVerificationRequestsListResult> {
    const url = new URL(`${config.apiUrl}/compliance/kyc-requests`);
    url.searchParams.set("limit", String(query.limit ?? 20));
    url.searchParams.set("offset", String(query.offset ?? 0));
    if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
    if (query.filters)
      url.searchParams.set("filters", JSON.stringify(query.filters));
    return fetcher.get<KycVerificationRequestsListResult>(url.toString());
  },

  async getDetail(id: string): Promise<KycVerificationRequestDetail> {
    return fetcher.get<KycVerificationRequestDetail>(
      `${config.apiUrl}/compliance/kyc-requests/${id}`,
    );
  },

  async approve(id: string): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/compliance/kyc-requests/${id}/approve`,
    );
  },

  async reject(id: string, reason?: string): Promise<{ ok: boolean }> {
    return fetcher.post<{ ok: boolean }>(
      `${config.apiUrl}/compliance/kyc-requests/${id}/reject`,
      { reason },
    );
  },
};
